import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MaterialLibraryModule } from '@cdw-ae/common-frontend-materials';

import { CdwCheckboxComponent } from './cdw-checkbox/cdw-checkbox.component';

@NgModule({
  imports: [CommonModule, MaterialLibraryModule],
  declarations: [CdwCheckboxComponent],
  exports: [CdwCheckboxComponent],
})
export class CdwCheckboxModule {}
